// Single source of truth for the country dropdown across register /
// complete-profile / profile pages, plus the mapping used to resolve the
// number-formatting locale from the user's stored profile country.

export const COUNTRIES = [
  "Norway",
  "Sweden",
  "Denmark",
  "Finland",
  "Iceland",
  "United Kingdom",
  "Germany",
  "United States",
  "Other",
] as const;

export type Country = (typeof COUNTRIES)[number];

// Country -> BCP47 locale used *only* for number/money formatting. Date and
// other locale-sensitive display continues to follow the UI language.
const COUNTRY_TO_NUMBER_LOCALE: Partial<Record<string, string>> = {
  Norway: "nb-NO",
  Sweden: "sv-SE",
  Denmark: "da-DK",
  Finland: "fi-FI",
  Iceland: "is-IS",
  "United Kingdom": "en-GB",
  Germany: "de-DE",
  "United States": "en-US",
};

/**
 * Resolve a number-formatting locale for a profile country.
 * Returns null for unknown / "Other" / unset — callers should fall back
 * to the UI-language locale.
 */
export function countryToNumberLocale(country: string | null | undefined): string | null {
  if (!country) return null;
  return COUNTRY_TO_NUMBER_LOCALE[country] ?? null;
}
